import React, { useEffect, useRef, useState } from "react";
import { logException } from "@wss/error-tracking";
import Carousel from "./Carousel";
import EmailSignUp from "./EmailSignUp";
import FooterText from "./FooterText";
import { InactivePageModel } from "./InactivePage";
import PageHeader from "./PageHeader";
import PopularBrands, { PopularBrand } from "./PopularBrands";
import PopularCategories from "./PopularCategories";
import getBrandsByUrl from "./getBrandsByUrl";

export default ({
  pageName,
  backgroundImageUrl,
  popularCategories,
  footerTitle,
  footerDescription,
  featuredProducts,
}: InactivePageModel) => {
  const [popularBrands, setPopularBrands] = useState<PopularBrand[]>([]);
  const hasPopularBrands = useRef<boolean>(false);

  const popularBrandUrls = [
    { name: "Avantco Equipment", url: "avantco-equipment" },
    { name: "Choice", url: "choice" },
    { name: "Acopa", url: "acopa" },
    { name: "AvaMix", url: "avamix" },
    { name: "Noble Chemical", url: "noble-chemical" },
  ];

  useEffect(() => {
    const getPopularBrands = async () => {
      if (!hasPopularBrands.current) {
        hasPopularBrands.current = true;
        const response = await getBrandsByUrl(
          popularBrandUrls.map((brandUrl) => brandUrl.url),
        );
        if (response.isError) {
          await logException(response.error);
          return;
        }
        const brandsResult = response.value;

        // create a new array to preserve the same order as the list above
        const popularBrands: PopularBrand[] = popularBrandUrls.map(
          (brandUrl) => {
            const brand = brandsResult.find(
              (brandResult) => brandResult.name === brandUrl.name,
            );

            const result: PopularBrand = {
              name: brand?.name ?? "",
              image: brand?.image ?? "",
              link: brand?.link ?? "",
            };
            return result;
          },
        );

        setPopularBrands(popularBrands);
      }
    };

    getPopularBrands();
  }, [popularBrandUrls]);

  return (
    <div
      data-module="initPageCreatorInactivePage"
      className="holiday-everliving"
    >
      <PageHeader pageName={pageName} backgroundImageUrl={backgroundImageUrl} />
      <EmailSignUp />
      <div className="container no-touchevents">
        <PopularCategories categories={popularCategories} />
        <Carousel products={featuredProducts} />
        <PopularBrands popularBrands={popularBrands} />
        <FooterText title={footerTitle} description={footerDescription} />
      </div>
    </div>
  );
};
